import { useMemo, useReducer } from 'react';
import type { FunctionComponent, ReactNode } from 'react';

import FailedOrdersContext from './FailedOrdersContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';

const FailedOrdersProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <FailedOrdersContext.Provider value={{ actions, state }}>
      {children}
    </FailedOrdersContext.Provider>
  );
};

export default FailedOrdersProvider;
